import { render, staticRenderFns } from "./TaskCard.vue?vue&type=template&id=23ebc8fb&scoped=true&"
import script from "./TaskCard.vue?vue&type=script&lang=js&"
export * from "./TaskCard.vue?vue&type=script&lang=js&"
import style0 from "./TaskCard.vue?vue&type=style&index=0&id=23ebc8fb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23ebc8fb",
  null
  
)

export default component.exports